import React from "react";
import { string, shape, array, object, oneOf, bool } from "prop-types";

import ImageElement from "../ImageElement/ImageElement.jsx";
import ShareBarMount from "../ShareBar/ShareBarMount.jsx";
import ArrowLink from "../ArrowLink/ArrowLink.jsx";

import cx from "classnames";

const propTypes = {
  image: shape({
    alt: string,
    sources: array,
  }),
  title: string.isRequired,
  body: string,
  contentType: string,
  authors: array,
  cta: shape({
    href: string.isRequired,
    text: string,
    type: oneOf(["", "external", "download", "anchor", "arrow"]),
    title: string,
  }),
  location: string,
  shareData: object,
  fullWidth: bool,
  darkTheme: bool,
  focusRef: object,
  date: string,
  updatedLabel: string,
  lang: string,
  gtmElementBaseLabel: string,
  applyGate: bool,
  gateColor: string,
};

const articlePromo = (props) => {
  const {
    title,
    body,
    contentType,
    cta,
    authors,
    location,
    shareData,
    fullWidth,
    darkTheme,
    focusRef,
    date,
    updatedLabel,
    lang,
    gtmElementBaseLabel,
    applyGate,
    gateColor,
  } = props;

  const image = props.image ? processImage(props.image) : null;

  function processImage(image) {
    return {
      alt: image.alt,
      srcSet: image.srcSet
        ? image.srcSet
        : image.sources
          ? image.sources.join(", ")
          : null,
      sizes: image.sizes || null,
      width: image.width || null,
      height: image.height || null,
    };
  }

  return (
    <section
      className={cx("article-promo", "component", {
        "article-promo--full-width": fullWidth,
        "article-promo--dark": darkTheme,
        "article-promo--gate": applyGate,
      })}
      style={{ "--gate-color": gateColor }}
    >
      {image && image.srcSet && (
        <figure
          className={cx("article-promo__media", {
            "gate-style-horizontal": applyGate,
          })}
        >
          <a
            href={cta.href}
            title={title}
            data-gtm-element={
              gtmElementBaseLabel
                ? `${gtmElementBaseLabel} article promo image link`
                : "article promo image link"
            }
            data-gtm-link={cta.href}
          >
            <ImageElement {...image} />
          </a>
        </figure>
      )}
      <div className="article-promo__content">
        <div className="article-promo__content-head">
          {contentType && (
            <div className="article-promo__eyebrow">{contentType}</div>
          )}
          <h2 className="article-promo__title">
            <ArrowLink
              type={cta.type}
              href={cta.href}
              text={title}
              focusRef={focusRef}
              hrefLang={lang || null}
              gtmElementLabel={
                gtmElementBaseLabel
                  ? `${gtmElementBaseLabel} article promo link`
                  : "article promo link"
              }
            />
          </h2>
        </div>
        <div className="article-promo__content-body">
          {body && (
            <div
              className="article-promo__description"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          )}
          {authors && authors.length > 0 && (
            <div className="article-promo__author">
              {authors.length > 0 && (
                <span className="article-promo__author-text">
                  {authors.length > 2
                    ? `${authors.slice(0, -1).join(", ")}, and ${authors[authors.length - 1]
                    }`
                    : authors.join(" and ")}
                </span>
              )}
              {location && (
                <span className="article-promo__location">{location}</span>
              )}
            </div>
          )}
          {date && (
            <div className="article-promo__updated">
              {updatedLabel && (
                <span className="article-promo__updated-label">
                  {updatedLabel}
                </span>
              )}
              <span className="article-promo__updated-value">{date}</span>
            </div>
          )}
          {shareData && (
            <div className="article-promo__share">
              <ShareBarMount {...shareData} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

articlePromo.propTypes = propTypes;
export default articlePromo;
